<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
        <v-row>
          <v-col cols="12" class="pa-0">
            <h2 style="padding-top: -5px;"> 
  			    	<b style="padding-left: 10px !important;">По итогам Курчатовского форума синхротронных и нейтронных исследований (Курчатов ФСНИ-2023) опубликован сборник тезисов.</b>
	      		</h2>
          </v-col>
        </v-row>


        <v-row>
          <b class="ml-4" style="padding-left: 10px !important;">Сборник доступен на сайте Научной электронной библиотеки 
            <a href="https://www.elibrary.ru/item.asp?id=67357671">Elibrary.ru по ссылке</a></b>


        </v-row>
        <v-row>
          <b class="ml-4" style="padding-left: 10px !important;">Или скачайте сборник в формате PDF:  
            <a href="https://api.kcsni-service.ru/media/rsini/%D0%A2%D0%B5%D0%B7%D0%B8%D1%81%D1%8B_%D0%A4%D0%A1%D0%9D%D0%98_2023.pdf">Тезисы ФСНИ-2023.pdf</a></b>
        </v-row>
      </v-card>
  </div>
</template>
<script>

export default {
  name: 'Thesis23',
  data: () => ({
  }),

};
</script>
<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
